/**
 * 태그 줄 가로 위치 맞추기.
 *
 * 선택한 칩을 태그 줄 가운데로 끌어온다. 끝에 있는 칩은 화면 밖이거나 잘려 있어서
 * 무엇이 선택됐는지 보이지 않기 때문이다. 스크롤 양 끝에서는 더 갈 곳이 없으므로
 * 브라우저가 알아서 처음/끝에 붙인다.
 */
export const centerTagChip = (chip, behavior = 'auto') => {
  const rail = chip?.closest('.academy-tags');

  if (!rail || rail.scrollWidth <= rail.clientWidth) {
    return; // 스크롤할 것이 없다
  }

  const railBox = rail.getBoundingClientRect();
  const chipBox = chip.getBoundingClientRect();
  const delta = chipBox.left + chipBox.width / 2 - (railBox.left + railBox.width / 2);

  rail.scrollTo({ left: rail.scrollLeft + delta, behavior });
};

export default centerTagChip;
